import React, { useState } from 'react';
import { Header } from '../header/header.js';
import { useNavigate, Link } from 'react-router-dom';
import { Container} from 'react-bootstrap';
import './ErrorPage.css';
import { useTranslation } from 'react-i18next';

function ErrorPage() {
  const navigate = useNavigate();
  const [lenguage, setLanguage] = useState('es');
  const { t, i18n } = useTranslation();

  const onChangeLanguage = (newLanguage) => {
    setLanguage(newLanguage);
    i18n.changeLanguage(newLanguage);
  };

  return (
    <Container fluid>
      <Header setLanguage={onChangeLanguage} />
      <div className="cont">
        <div className="card">
          <h1 className="title">ERROR</h1>
          <p className="description">{t('errorPage')}<Link className="link" to='/'>{t('errorLink')}.</Link></p>
        </div>
      </div>
    </Container>
  );
}

export default ErrorPage;
